import { render, staticRenderFns } from "./TaskReport.vue?vue&type=template&id=d85440be&"
import script from "./TaskReport.vue?vue&type=script&lang=ts&"
export * from "./TaskReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports